<mat-checkbox
  class="custom-checkbox"
  color="primary"
  [checked]="isChecked"
  [indeterminate]="isIndeterminate"
  (change)="onChange($event.checked)">
  <ng-content></ng-content>
</mat-checkbox>
